const HedgesIcon = (props: any) => {
    return <img {...props} alt="hedges.png" src={require('./hedges.png')} />;
};

export default HedgesIcon;
